import Label from "@components/Label";
import {
  Box,
  CircularProgress,
  IconButton,
  Palette,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { FileText, FileSpreadsheet, X } from "lucide-react";

interface IAttachmentChipProps {
  name: string;
  palette: Palette;
  isLoading?: boolean;
  error?: string;
  onRemove?: () => void;
  onClick?: () => void;
}

export const AttachmentChip = ({
  name,
  palette,
  isLoading = false,
  error,
  onRemove,
  onClick,
}: IAttachmentChipProps) => {
  const isExcelOrCsv =
    name.toLowerCase().endsWith(".csv") || name.toLowerCase().endsWith(".xlsx");
  const isClickable = !!onClick && !isLoading && !error;

  return (
    <Tooltip title={error || ""}>
      <span
        onClick={isClickable ? onClick : undefined}
        style={{ cursor: isClickable ? "pointer" : undefined }}
      >
        <Label
          color={error ? "error" : "default"}
          variant="outlined"
          sx={{
            py: 0.75,
            px: 1,
            border: `1px solid ${
              error ? palette.error.main : palette.text.borderLine
            }`,
            background: error ? palette.error.lighter : "#eaebf3",
            color: error ? palette.error.dark : palette.text.primary,
            cursor: isClickable ? "pointer" : "default",
          }}
        >
          <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {isLoading ? (
                <CircularProgress size={12} />
              ) : isExcelOrCsv ? (
                <FileSpreadsheet size={12} />
              ) : (
                <FileText size={12} />
              )}
            </Box>
            <Typography
              variant="body2"
              title={name}
              sx={{
                fontSize: "10px",
                maxWidth: 100,
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
              }}
            >
              {name}
            </Typography>
            {onRemove ? (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <IconButton
                  disabled={isLoading}
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemove();
                  }}
                  sx={{ p: 0.5 }}
                >
                  <X size={12} />
                </IconButton>
              </Box>
            ) : null}
          </Stack>
        </Label>
      </span>
    </Tooltip>
  );
};
